module.exports = __webpack_public_path__ + "static/media/Ellipse 3.bbf64a8f.png";